import { atomWithInfiniteQuery } from "jotai-tanstack-query";
import { getUserActivities } from "../../apis";
import { authAtom } from "../auth/atoms";

type PageParam = {
  offset: number;
  length: number;
};
export const userActivityAtom = atomWithInfiniteQuery((get) => ({
  queryKey: ["userActivities", get(authAtom).data?.accessToken],
  queryFn: async (params) => {
    console.log("Getting user activities");
    const pageParam = params.pageParam as PageParam;
    const user = get(authAtom);
    if (!user) {
      throw new Error("User not found");
    }
    const response = await getUserActivities(
      user.data?.accessToken,
      pageParam.offset,
      pageParam.length
    );
    return response;
  },
  getNextPageParam: (lastPage, allPages, lastPageParam: PageParam) => ({
    ...lastPageParam,
    offset: lastPageParam.offset + 10,
  }),
  initialPageParam: {
    length: 10,
    offset: 0,
  },
  enabled: false,
}));
